export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>全网热播 · 实时更新</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              努努影院 · 免费高清电视剧在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              最新剧集实时更新，播放不缓冲，流畅追剧首选
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              努努影院专注高清电视剧全集免费在线观看，汇聚海内外热门剧集资源。每日同步更新最新剧集，1080P高清画质搭配智能加速引擎，确保播放流畅不卡顿。无论是国产热播剧、韩剧美剧还是经典老剧，这里都能一站畅享，让追剧成为一种纯粹的快乐。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">50+</div>
                <div className="text-xs text-foreground-500 mt-1">日更新剧集</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">1080P</div>
                <div className="text-xs text-foreground-500 mt-1">全高清画质</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">10000+</div>
                <div className="text-xs text-foreground-500 mt-1">覆盖剧集数</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#carousel"
                onClick={(e) => handleScrollTo(e, '#carousel')}
                className="inline-flex items-center gap-2 px-8 py-3 border border-background-300 text-foreground-700 rounded-full font-medium text-sm hover:border-primary-300 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                精选专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20composition%20of%20a%20modern%20cozy%20living%20room%20with%20a%20large%20floating%20flat%20screen%20displaying%20vibrant%20colorful%20abstract%20streaming%20visuals%20in%20coral%20and%20warm%20golden%20tones%2C%20soft%20ambient%20lighting%2C%20plants%20and%20decorative%20elements%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20clean%20minimalist%20aesthetic%2C%20harmonious%20warm%20neutral%20color%20palette&width=960&height=720&seq=hero-main-visual-001&orientation=landscape"
                alt="努努影院高清电视剧在线观看"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  target.parentElement!.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}